module.exports = __webpack_public_path__ + "img/2.914ef0dd.png";